import {useCallback, useRef, useState} from "react";
import CommerceCheckout from "./commerce-checkout";
import {buildCommercePayload} from "./commerce-payload";

export function useCommerceCheckout() {
    const [quoteLoading, setQuoteLoading] = useState(false);
    const [checkoutLoading, setCheckoutLoading] = useState(false);
    const quoteRequest = useRef(0);

    const getQuote = useCallback(async ({planPrice, discountCode, seats, customizations}) => {
        const model = new CommerceCheckout();
        const requestId = ++quoteRequest.current;
        setQuoteLoading(true);
        try {
            const response = await model.quote(buildCommercePayload({planPrice, discountCode, seats, customizations}));
            return response?.data || null;
        } finally {
            if (requestId === quoteRequest.current) setQuoteLoading(false);
        }
    }, []);

    const checkout = useCallback(async ({planPrice, discountCode, seats, customizations, idempotencyKey}) => {
        const model = new CommerceCheckout();
        setCheckoutLoading(true);
        try {
            const response = await model.checkout(buildCommercePayload({
                planPrice,
                discountCode,
                seats,
                customizations,
                idempotencyKey,
            }));
            return response?.data || null;
        } finally {
            setCheckoutLoading(false);
        }
    }, []);

    return {getQuote, checkout, quoteLoading, checkoutLoading};
}
